import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "9a24b66f-2339-4822-8abd-e9e137a38653", content: "Separation of the leaves", options: {} },
  { id: "b86c2fec-1663-45a4-a5a5-d8847f9e2fad", content: "Large gap between the leaves", options: {} },
  { id: "a0d6a451-3236-4cdd-8d9c-1c93397dd398", content: "Gap loosely filled  ", options: {} },
  { id: "8c773873-6485-4bb0-9b5c-940c7ac68fbf", content: "Independent stud construction", options: {} },
  { id: "0a0d3d4f-44ba-469d-b13b-4ee0944e3e88", content: "High surface mass of the leaves", options: {} },
  { id: "8bbe742a-f719-4bc6-a058-aaed1ba55bd9", content: "Hard connection of the leaves", options: {} },
  { id: "68dfc7ac-59ae-4da4-87a8-ff513bfd649d", content: "High fundamental resonance", options: {} },
  { id: "57cba28f-b099-42d7-b26e-7f8448b3ac6e", content: "Gap left empty", options: {} },
  { id: "336bddba-14a0-4793-b6a1-f38f80a3dff8", content: "Gap heavily stuffed ", options: {} },
  { id: "1da5cdfc-150b-48d5-ae52-d4af7b4571fa", content: "Common stud construction", options: {} },
];

export const task: Task = {
  id: "6be24cfe-ea68-4307-99dc-0a1e0abae746",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "9a24b66f-2339-4822-8abd-e9e137a38653",
    "b86c2fec-1663-45a4-a5a5-d8847f9e2fad",
    "a0d6a451-3236-4cdd-8d9c-1c93397dd398",
    "8c773873-6485-4bb0-9b5c-940c7ac68fbf",
    "0a0d3d4f-44ba-469d-b13b-4ee0944e3e88",
  ],
};
